import React from 'react';
import styled, { css } from 'styled-components';
import Icon from './Icon';
import { flexCenter, breakpoints, palette } from '../../constants/styles';
import Text from '../shared/Text';
import { phoneNumber } from '../../constants/constants';

const StyledContacts = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Contact = styled.a`
  ${flexCenter}
  text-decoration: none;
  z-index: 100000;
  position: fixed;
  right: ${(props) => props.right}px;
  bottom: ${(props) => props.bottom}px;
`;

const StyledContactNundge = styled.div`
  ${flexCenter}
  display: none;
  position: relative;
  background-color: ${(props) => props.color};
  right: -30px;
  width: 0px;
  height: 55px;
  border-radius: 50px 0px 0px 50px;
  z-index: 10;

  transform: translate(0%);
  transition: 0.3s ease-out;

  ${breakpoints.tablet} {
    display: flex;
    width: 190px;
  }
`;

const StyledContactCircle = styled.div`
  ${flexCenter}
  background-color: ${(props) => props.color};
  width: 55px;
  height: 55px;
  border-radius: 27.5px;
  z-index: 20;
`;

export default function FloatingContact() {
  return (
    <StyledContacts>
      <Contact
        href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
          'Hola 👋 Tengo una pregunta...',
        )}`}
        bottom={90}
        right={20}
      >
        <StyledContactNundge color={`${palette.secondaryColor}AA`}>
          <Text type="body2" color="white" bold>
            Escríbenos
          </Text>
        </StyledContactNundge>
        <StyledContactCircle color={palette.secondaryColor}>
          <Icon
            icon="whatsapp"
            size={30}
            color="white"
            onClick={() => {
              console.log('User clicked on X');
            }}
          />
        </StyledContactCircle>
      </Contact>
      <Contact href={`tel:${phoneNumber}`} bottom={20} right={20}>
        <StyledContactNundge color={`${palette.primaryColor}AA`}>
          <Text type="body2" color="white" bold>
            Llámanos
          </Text>
        </StyledContactNundge>
        <StyledContactCircle color={palette.primaryColor}>
          <Icon
            icon="phone"
            size={32}
            color="white"
            styles={css`
              -moz-transform: scaleX(-1);
              -webkit-transform: scaleX(-1);
              -o-transform: scaleX(-1);
              transform: scaleX(-1);
              -ms-filter: fliph; /*IE*/
              filter: fliph; /*IE*/
            `}
            onClick={() => {
              console.log('User clicked on X');
            }}
          />
        </StyledContactCircle>
      </Contact>
    </StyledContacts>
  );
}
